// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import Zone from "@insite/client-framework/Components/Zone";
import siteMessage from "@insite/client-framework/SiteMessage";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import { HiddenProps } from "@insite/mobius/Hidden";
import Typography from "@insite/mobius/Typography";
import React from "react";
import { css } from "styled-components";

export interface QuickOrderPageContainerStyles {
    container?: GridContainerProps;
    firstGridItem?: GridItemProps;
    innerContainer?: GridContainerProps;
    leftColumnGridItem?: GridItemProps;
    rightColumnGridItem?: GridItemProps;
    rightColumnGridItemHidden?: HiddenProps;
    secondGridItem?: GridItemProps;
    thirdGridItem?: GridItemProps;
    thirdGridItemHidden?: HiddenProps;
    bottomGridItem?: GridItemProps;
    // XNG-Changes
    bottomGridContainer?: GridContainerProps;
}

export const quickOrderPageContainerStyles: QuickOrderPageContainerStyles = {
    firstGridItem: { width: 12 },
    leftColumnGridItem: { width: [12, 12, 6, 4, 4] },
    rightColumnGridItem: { width: [0, 0, 6, 8, 8] },
    rightColumnGridItemHidden: {
        below: "md",
        css: css`
            width: 100%;
        `,
    },
    secondGridItem: { width: 12 },
    thirdGridItem: { width: [12, 12, 0, 0, 0] },
    thirdGridItemHidden: {
        above: "sm",
        css: css`
            width: 100%;
        `,
    },
    bottomGridItem: { width: 12 },
};

/**
 * @deprecated Use quickOrderPageContainerStyles instead.
 */
export const viewStyles = quickOrderPageContainerStyles;
const styles = quickOrderPageContainerStyles;

const QuickOrderPageContainer = (props: WidgetProps) => {
    // XNG-Changes:change structure to match classic
    return (
        <GridContainer {...styles.container}>
            <GridItem width={12}>
                <Zone contentId={props.id} zoneName="Content0" />
            </GridItem>
            <GridItem {...styles.secondGridItem}>
                <Typography as="p">{siteMessage("QuickOrder_Instructions")}</Typography>
                <Zone contentId={props.id} zoneName="Content1" />
            </GridItem>
            <GridItem {...styles.thirdGridItem}>
                <Zone contentId={props.id} zoneName="Content2" />
            </GridItem>

            <GridItem {...styles.bottomGridItem}>
                <GridContainer {...styles.bottomGridContainer} gap={20}>
                    <GridItem width={[12, 9, 9, 9, 9]}>
                        <Zone contentId={props.id} zoneName="Content3" />
                    </GridItem>
                    <GridItem width={[12, 3, 3, 3, 3]}>
                        <Zone contentId={props.id} zoneName="Content4" />
                    </GridItem>
                </GridContainer>
            </GridItem>
        </GridContainer>
    );
};

const widgetModule: WidgetModule = {
    component: QuickOrderPageContainer,
    definition: {
        displayName: "Page Container",
        group: "Quick Order",
        allowedContexts: ["QuickOrderPage"],
    },
};

export default widgetModule;
